import { render, staticRenderFns } from "./ReportesCantidadTerminales.vue?vue&type=template&id=48db4027&"
import script from "./ReportesCantidadTerminales.vue?vue&type=script&lang=js&"
export * from "./ReportesCantidadTerminales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports